import { render } from "./logo-icon-only.svg?vue&type=template&id=415c3206"
const script = {}
script.render = render

export default script